import axios from 'axios'
import {BUSCAR_LOCALIZACAO_VEICULO} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarLocalizacaoVeiculo(idVeiculo, idEmpresa) {
    const url = `${URL}/veiculo/${idVeiculo}/empresa/${idEmpresa}/localizacao`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_LOCALIZACAO_VEICULO,
            payload: response

        })
    );
}
